export default __webpack_public_path__ + "static/media/users-edit-form.0e2b1e8c.png";